import { render, staticRenderFns } from "./DocumentProperties.vue?vue&type=template&id=84d727ca&scoped=true&"
import script from "./DocumentProperties.vue?vue&type=script&lang=js&"
export * from "./DocumentProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d727ca",
  null
  
)

export default component.exports